angular.module('impactx.catalog').controller('CheckedInCatalogListCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'searchFilter',
    'BackService',
    '$redirect',
    'ToastService',
    'selectedListItems',
    '$config',
    '$securityManager',
    'ToolbarService',
    'OneTimeDataTransporter',
    'SearchFilter',
    CheckedInCatalogListController
]);

function CheckedInCatalogListController($scope, dataGen, $routeParams, searchFilter, BackService, $redirect, ToastService, selectedListItems, $config, $securityManager, ToolbarService, OneTimeDataTransporter, SearchFilter) {
    var self = this;

    if ($routeParams.cmrlId > 0) {
        var dataFromTransporter = OneTimeDataTransporter.getData();
        var cmrlName = dataFromTransporter ? dataFromTransporter.cmrlName : "";
        searchFilter.getSearchFilterData().cmrlId = {value: $routeParams.cmrlId, label: cmrlName};
        $scope.cmrlName = cmrlName;
        $scope.numberOfErrorItems = $routeParams.numberOfErrorItems;
    }
    else if ($routeParams.productLabelKeyValue)
    {
        searchFilter.getSearchFilterData().cmrlId = {};
        $scope.productLabelKeyValue = $routeParams.productLabelKeyValue;
        $scope.numberOfItems = $routeParams.numberOfItems;
        searchFilter.getSearchFilterData().productLabelKey = {value: $routeParams.productLabelKeyValue};
    }
    else {
        searchFilter.getSearchFilterData().cmrlId = {};
        searchFilter.getSearchFilterData().productLabelKey = {};
    }

    $scope.catId = $routeParams.id;
    $scope.hideProductFamily = true;
    $scope.hideCategory = true;
    $scope.hideSupplier = true;
    $scope.selectedProducts = [];
    $scope.showSearch = {value: true};
    this.exists = searchFilter.exists;
    this.useSearchFilterFactoryForDrilldown = true;

    searchFilter.clearSearchInput();
    SearchFilter.resetSearch();
    if (searchFilter.getSearchFilterData()) {
        searchFilter.getSearchFilterData().drillDowns = [];
    }
    $scope.dynamicItems = selectedListItems.createDynamicItems($scope, 'data.products');

    self.setLocalFilterSettings = function () {

        $scope.no_result = impactX.valueOrDefault($scope, 'data.products.length', 0) < 1;

        //Copy values
        $scope.filters = [];
        $scope.filters.push(searchFilter.getSearchFilterData().vcatalogId);
        $scope.searchFilter = searchFilter;

        $scope.fixedFilters = searchFilter.getSearchFilterData();
        $scope.searchFilter = searchFilter;

        self.facetResults = [];
    };

    this.hasOneProductSelected = function () {
        return $scope.selectedProducts && $scope.selectedProducts.length === 1 && self.hasNoCompilationArticleSelected();
    };

    this.hasNoCompilationArticleSelected = function () {
        return ($scope.selectedProducts.filter(function (product) {
            return product.isCompilationArticle;
        }).length <= 0);
    };

    this.hasProductsSelected = function () {
        return $scope.selectedProducts && $scope.selectedProducts.length > 0;
    };

    this.hasNoProductSelected = function () {
        return !$scope.selectedProducts || !$scope.selectedProducts.length || $scope.selectedProducts.length === 0;
    };

    self.unSelectAll = function () {
        $scope.selectedProducts.forEach(function (product) {
            product.selected = false;
        });
        $scope.selectedProducts.length = 0;
    };

    self.selectAll = function () {
        $scope.data.products.forEach(function (product) {
            $scope.selectedProducts.push(product);
            product.selected = true;
        });
    };

    self.selectProduct = function (product) {
        if (product.selected) {
            var index = $scope.selectedProducts.indexOf(product);
            if (index > -1) {
                $scope.selectedProducts.splice(index, 1);
            }
        }
        else {
            $scope.selectedProducts.push(product);
        }
        product.selected = !product.selected;
    };

    this.getSelectedItemsLabel = function () {
        return $scope.selectedProducts && $scope.selectedProducts.length > 0 ? $scope.selectedProducts.length + ' ' + $scope.trns.selected : "";
    };

    this.getProductDetailLink = function () {
        return $scope.selectedProducts[0] ? "editproductreadonly/" + $scope.selectedProducts[0].id + "/" + $scope.catId : "";
    };

    this.getProductMediaLink = function () {
        return $scope.selectedProducts[0] ? "viewproductmedia/" + $scope.selectedProducts[0].id : "";
    };

    self.search = function () {
        self.unSelectAll();

        var transferObject = {
            id: $scope.catId,
            filters: searchFilter.getSearchFilterData()
        };

        dataGen.postAsForm($scope, transferObject, '/catalog/list/checkedincatalog').then(function (data) {
            var attributeSearch;

            if (impactX.isDefined($scope, 'data.searchError')) {
                ToastService.openStandardToast($scope.data.searchError);
            }

            $scope.no_result = impactX.valueOrDefault($scope, 'data.products.length', 0) < 1;
            $scope.filters = [];
            $scope.filters.push(searchFilter.getSearchFilterData().vcatalogId);
            $scope.fixedFilters = searchFilter.getSearchFilterData();
            $scope.searchFilter = searchFilter;

            attributeSearch = $scope.data.attributeSearch;

            if (attributeSearch) {
                self.facetResults = attributeSearch.facetResults;
                self.guidedFacetResult = attributeSearch.guidedFacetResult;
            }
            else {
                self.facetResults = [];
            }
            defineButtons();
        });
    };

    self.deleteCmrlFilter = function () {
        $redirect.redirectTo(null, "/checkedincataloglist/" + $scope.catId);
    };

    // ugly but I don't wanna refactor all templates to work with the functions assigned to the controller
    $scope.search = function () {
        self.search();
    };

    self.reload = function () {
        //$scope.selectedProducts.length = 0;
        $scope.selectedProducts = [];
        this.search();
    };

    self.toggleDrillDown = function (item) {
        searchFilter.toggleDrillDown(item);
        $scope.search();
    };

    self.toggleSearch = function () {
        $scope.showSearch.value = !$scope.showSearch.value;
    };

    self.printResult = function () {
        print($routeParams.cmrlId, $scope.catId);
    };

    self.print = function () {
        print(0, $scope.catId);
    };

    var print = function (cmrliId, catId) {
        var form = document.createElement('form');
        form.action = $config.sourceURL + "/print/list/exportpro";
        form.method = 'POST';
        form.target = 'print';
        form.style.display = 'none';

        var inputt = document.createElement('input');
        inputt.type = 'text';
        inputt.name = 'token';
        inputt.value = $securityManager.getToken();

        var input = document.createElement('input');
        input.name = 'cmrliId';
        input.value = cmrliId;

        var input2 = document.createElement('input');
        input2.name = 'catId';
        input2.value = catId;

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input);
        form.appendChild(input2);
        form.appendChild(inputt);
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    };


    //DIRTY ...
    if (!searchFilter.wasInitialized) {
        //We need configuration for search filters. Otherwise weird results.
        searchFilter.initSearchFilter().then(function () {
            self.setLocalFilterSettings();
            self.search();
        });
    }
    else {
        self.setLocalFilterSettings();
        self.search();
    }

    var checkFilter = function (filter) {
        return !!(filter && (filter.value || filter.selected))
    };


    self.anyFiltersSet = function () {
        var filterdata = $scope.fixedFilters;
        if (filterdata) {
            if (filterdata.drillDowns && filterdata.drillDowns.length > 0) {
                return true;
            }
            return !!searchFilter.searchInput
                || checkFilter(filterdata.supplier)
                || checkFilter(filterdata.manufacturer)
                || checkFilter(filterdata.contractNo)
                || checkFilter(filterdata.supplierNo)
                || checkFilter(filterdata.category)
                || checkFilter(filterdata.sort)
                || checkFilter(filterdata.priceRange.minValue)
                || checkFilter(filterdata.priceRange.maxValue);
        }
        return false;
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                icon: 'mdi-close',
                labelFunction: self.getSelectedItemsLabel,
                action: self.unSelectAll,
                condition: self.hasProductsSelected
            },
            {
                label: $scope.trns.ruleCheck,
                linkFunction: getRuleCheckListLink,
                type: 'link',
                condition: canSeeRules
            },
            {
                label: $scope.trns.print,
                action: self.printResult,
                type: 'dialogaction',
                condition: canPrintResult
            },
            {
                label: $scope.trns.print,
                action: self.print,
                type: 'dialogaction',
                condition: canPrint
            },
            {
                label: $scope.trns.details,
                linkFunction: self.getProductDetailLink,
                type: 'link',
                condition: self.hasOneProductSelected,
                process: 'EditCatalog'
            },
            {
                label: $scope.trns.mediaAndAttachments,
                linkFunction: self.getProductMediaLink,
                type: 'link',
                condition: self.hasOneProductSelected,
                process: 'EditCatalog'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function getRuleCheckListLink() {
        return "catalogrulechecklist/" + $scope.catId;
    }

    function canSeeRules() {
        return !self.hasProductsSelected() && !$routeParams.hideRules;
    }

    function canPrintResult() {
        return $scope.cmrlName && !self.hasProductsSelected();
    }

    function canPrint() {
        return !$scope.cmrlName && !self.hasProductsSelected();
    }
}
